import { LegalShell, type LegalSection } from './_shared';

const SECTIONS: LegalSection[] = [
  {
    h: 'The vibe',
    body: (
      <p>
        Nearmirer is for a genuine, low-stakes "hey, I noticed you" — a compliment, a shared laugh,
        a conversation. Anonymity is a feature, not a shield. Talk to people the way you would if
        they could see your face.
      </p>
    ),
  },
  {
    h: 'Do',
    body: (
      <ul className="list-disc space-y-1 pl-5">
        <li>Compliment something specific and kind — the outfit, the energy, the music taste.</li>
        <li>Take "no" or silence as a full answer.</li>
        <li>Keep it PG until both people clearly want otherwise.</li>
        <li>Report anything that crosses a line. It helps everyone.</li>
      </ul>
    ),
  },
  {
    h: "Don't",
    body: (
      <ul className="list-disc space-y-1 pl-5">
        <li>Harass, insult, follow up after being ignored, or pressure anyone.</li>
        <li>Send unsolicited sexual content or comments about someone's body.</li>
        <li>
          Push to move off-app, meet in private, or "just get your number" in the first message.
        </li>
        <li>
          Post hate or slurs targeting anyone's race, religion, gender, sexuality, disability, or
          origin.
        </li>
        <li>Threaten, intimidate, or joke about violence.</li>
        <li>
          Share anyone's identity, location, workplace, or private details ("doxxing") — including
          guessing publicly.
        </li>
        <li>Impersonate another person or claim to be someone in the room that you are not.</li>
        <li>Spam, advertise, scam, phish, or run bots.</li>
        <li>
          Use Nearmirer at or about schools, or to contact anyone you know or believe to be under
          18.
        </li>
      </ul>
    ),
  },
  {
    h: 'Zero tolerance',
    body: (
      <p>
        Sexual content involving minors, credible threats of violence, and coordinated harassment
        result in an immediate permanent ban and, where appropriate, a report to law enforcement.
      </p>
    ),
  },
  {
    h: 'How enforcement works',
    body: (
      <p>
        Most first-time, lower-level violations get a warning or a short mute (24 hours to 7 days).
        Repeat or serious violations escalate to a 30-day suspension or a permanent ban. A moderator
        reviews the reported content and the account's history before acting, and every action is
        logged. If you think a decision was wrong, reply to the notice to appeal.
      </p>
    ),
  },
  {
    h: 'If someone breaks the rules',
    body: (
      <p>
        Use the block button to make them disappear from your world instantly, and the report button
        to send the specific message (and only that message) to our team. You never have to explain
        yourself to the other person.
      </p>
    ),
  },
];

export function CommunityPage() {
  return (
    <LegalShell
      title="Community Guidelines"
      path="/community-guidelines"
      seoDescription="The house rules for Sparks, Whispers and Circles on Nearmirer — what's okay, what isn't, and how we enforce it."
      intro={
        <p>
          These rules are part of our Terms of Service. They apply to Sparks, Whispers, Circles,
          your profile, and any other content on Nearmirer.
        </p>
      }
      sections={SECTIONS}
    />
  );
}
